import { connect, ConnectedProps } from 'react-redux'

import Navigation from 'components/account/Navigation'
import { isRoles } from 'redux/actions'
import { RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { userIs: (props: string) => boolean } => ({
  userIs: (props: string) => isRoles(state, props)
})

const connector = connect(mapStateToProps, null)

export type NavigationContainerProps = ConnectedProps<typeof connector>

export default connector(Navigation)
